/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IGdnInvoicesList contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export interface IGdnInvoicesListConfig extends Msdyn365.IModuleConfig {
    invoiceTypes?: IInvoiceTypesData[];
    paymentAddedMessage?: string;
    heading?: IHeadingData;
    itemsPerPage?: number;
    className?: string;
    clientRender?: boolean;
    renderListView?: boolean;
    allowMultipleInvoicePayment?: boolean;
    partsInCartPaymentMessage?: string;
    paymentPendingMessage?: string;
    invoiceTotalsDisclaimerMessage?: Msdyn365.RichText;
    displayInvoicePaymentTotals?: boolean;
    allowCreditPayment?: boolean;
    notAdminMessage?: string;
    payAllDueInvoiceModalLabels?: IPayAllDueInvoiceModalLabelsData;
    enablePayDueInvoices?: boolean;
    payDueInvoicesLimit?: number;
    payDueInvoicesLimitMessage?: string;
    addDueInvoicesToCartButtonLabel?: string;
}

export interface IGdnInvoicesListResources {
    payInvoiceButtonText: string;
    payInvoiceButtonAriaLabel: string;
    makePaymentButtonText: string;
    makePaymentButtonAriaLabel: string;
    invoicesListTitle: string;
    invoicesListDescTitle: string;
    invoicesListDescCount: string;
    invoiceNumberText: string;
    invoiceDateText: string;
    invoiceUsersText: string;
    invoiceAmountText: string;
    invoiceDueDateText: string;
    invoiceAmountDueText: string;
    invoiceStatusText: string;
    invoiceActionsText: string;
    invoiceStatusNone: string;
    invoiceStatusUnpaid: string;
    invoiceStatusPartiallyPaid: string;
    invoiceStatusPaid: string;
    invoiceCurrentUser: string;
    invoiceViewDetailsButtonText: string;
    invoiceViewDetailsButtonAriaLabel: string;
    invoiceActionsButtonTextAriaLabel: string;
    invoiceActionsButtonIsOnBehalfOfTextAriaLabel: string;
    invoicesText: string;
    invoiceDateMobileText: string;
    invoiceEmptyInvoiceLinesTitle: string;
    invoiceEmptyInvoiceLinesDescription: string;
    invoiceEmptyInvoiceLinesContinueShoppingButtonText: string;
    invoiceEmptyInvoiceLinesContinueShoppingButtonAriaLabel: string;
    invoiceErrorMessageHeader: string;
    invoiceErrorInvoiceIdNotExist: string;
    invoiceErrorFailedAddInvoiceToCart: string;
    invoiceInCartPaymentMessage: string;
    invoiceRequestButtonLabel: string;
    invoiceRequestModalCancelLabel: string;
    invoiceRequestModalHeaderLabel: string;
    invoiceRequestModalSubmitLabel: string;
    invoiceRequestModalSendToEmailLabel: string;
    invoicesFilterShowAll: string;
    invoicesLoadMore: string;
    invoiceRequestModalSearch: string;
    invoiceRequestModalInvoiceSearchDisplay: string;
    invoiceRequestModalSingleInvoiceSearchDisplay: string;
    payInvoiceErrorDialogHeader: string;
    payInvoiceErrorDialogBodyErrorTitle: string;
    payInvoiceErrorDialogBodyErrorDescription: string;
    payInvoiceErrorDialogFooterGoToCartButtonText: string;
    payInvoiceErrorDialogFooterCancelButtonText: string;
    invoiceListSelectAllRadioAriaLabelText: string;
    invoiceListSelectRadioAriaLabelText: string;
    invoiceRequestModalSearchButton: string;
    requestInvoiceDialogAriaLabel: string;
    creditNoteLabel: string;
    freightDiscountWarningText: string;
    payText: string;
    addToCartText: string;
    specifyAmountText: string;
    resetAmountText: string;
    invoieDateText: string;
    salesOrderText: string;
    amountText: string;
    termsText: string;
    poText: string;
    pastDueText: string;
    nextPaymentText: string;
    paidText: string;
    discountText: string;
    amountDueText: string;
    amountPaidText: string;
    paymentText: string;
    dueText: string;
    statusText: string;
    allowableFreightText: string;
    futureDueText: string;
    currentDueText: string;
    totalAmountDueText: string;
    notAdminMessage: string;
    allDueText: string;
    currentDueFilterText: string;
    addDueInvoicesToCartButtonFallbackLabel: string;
    multiplePaymentsModalHeaderFallbackLabel: string;
    multiplePaymentsModalBodyFallbackLabel: string;
    okButtonLabel: string;
    payDueInvoicesLimitFallbackMessage: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface IPayAllDueInvoiceModalLabelsData {
    multiplePaymentsModalHeaderLabel?: string;
    multiplePaymentsModalBodyLabel?: string;
    okButtonLabel?: string;
}

export interface IGdnInvoicesListProps<T> extends Msdyn365.IModule<T> {
    resources: IGdnInvoicesListResources;
    config: IGdnInvoicesListConfig;
}

export const enum InvoiceTypesInvoiceType {
    None = 'None',
    SalesOrderInvoice = 'SalesOrderInvoice',
    FreeTextInvoice = 'FreeTextInvoice',
    ProjectInvoice = 'ProjectInvoice',
    CreditNoteInvoice = 'CreditNoteInvoice',
    FreeTextCreditNoteInvoice = 'FreeTextCreditNoteInvoice',
    ProjectCreditNoteInvoice = 'ProjectCreditNoteInvoice'
}

export interface IInvoiceTypesData {
    invoiceType?: InvoiceTypesInvoiceType;
}
